module.exports = __webpack_public_path__ + "static/media/image_part_011.4b88121c.jpg";